export default __webpack_public_path__ + "static/media/beautiful-young-latin-woman-driving-her-brand-new-car-showing-her-thumb-up.7a1883e1.jpg";